module.exports = __webpack_public_path__ + "img/teacher-nv.2cb70432.png";